<template>
  <div class="billing-page pk-bill-page">
    <section class="bill-hero">
      <div class="hero-copy">
        <span>账单明细</span>
        <h1>我的账单</h1>
        <p>充值记录、余额流水和商城购买记录统一展示，相关内容以当前账号账单为准。</p>
        <div class="hero-actions">
          <button @click="goPath('/Payment')">去充值</button>
          <button class="ghost" @click="goPath('/Dota')">查看背包</button>
        </div>
      </div>
      <div class="hero-orb">
        <i></i>
        <strong>{{ totalCount }}</strong>
        <em>条记录</em>
      </div>
    </section>

    <section v-if="loggedIn" class="bill-stats">
      <article>
        <span>充值记录</span>
        <strong>{{ totalSize }}</strong>
      </article>
      <article>
        <span>余额流水</span>
        <strong>{{ totalSize2 }}</strong>
      </article>
      <article>
        <span>商城记录</span>
        <strong>{{ totalSize1 }}</strong>
      </article>
      <article>
        <span>当前筛选</span>
        <strong>{{ activeTitle }}</strong>
      </article>
    </section>

    <section v-if="loggedIn" class="bill-board">
      <div class="tab-bar">
        <button :class="{ active: activeName == 'one' }" @click="switchTab('one')">
          充值流水
        </button>
        <button :class="{ active: activeName == 'three' }" @click="switchTab('three')">
          余额流水
        </button>
        <button :class="{ active: activeName == 'two' }" @click="switchTab('two')">
          饰品商城
        </button>
      </div>

      <div v-if="activeName == 'one'" class="record-list">
        <article v-for="item in tableData" :key="item.id" class="record-row">
          <div class="row-icon recharge"><i></i></div>
          <div class="row-main">
            <strong>{{ item.order_num }}</strong>
            <span>{{ item.create_time }}</span>
          </div>
          <div class="row-meta">
            <span>{{ payMode(item) }}</span>
            <em :class="statusClass(item.status)">{{ rechargeStatus(item.status) }}</em>
          </div>
          <div class="row-amount plus">{{ moneyText(item.coin_amount) }} <i></i></div>
        </article>
        <empty-card v-if="!tableData.length" text="暂无充值流水"></empty-card>
        <el-pagination
          v-if="totalSize > pageSize"
          class="bill-page-nav"
          background
          layout="prev, pager, next"
          :total="totalSize"
          :page-size="pageSize"
          @current-change="currentChange"
        ></el-pagination>
      </div>

      <div v-if="activeName == 'three'" class="record-list">
        <article v-for="item in tableData2" :key="item.id" class="record-row">
          <div class="row-icon balance" :class="currencyClass(item)"><i :class="currencyClass(item)"></i></div>
          <div class="row-main">
            <strong>{{ balanceState(item) }}</strong>
            <span>{{ item.create_time }}</span>
          </div>
          <div class="row-meta">
            <span>{{ currencyName(item) }}{{ Number(item.amount) >= 0 ? "收入" : "支出" }}</span>
            <em>{{ currencyName(item) }}余额 {{ moneyText(item.total_amount) }}</em>
          </div>
          <div class="row-amount" :class="{ plus: Number(item.amount) >= 0, minus: Number(item.amount) < 0 }">
            {{ signedAmount(item.amount) }} <i :class="currencyClass(item)"></i>
          </div>
        </article>
        <empty-card v-if="!tableData2.length" text="暂无余额流水"></empty-card>
        <el-pagination
          v-if="totalSize2 > pageSize"
          class="bill-page-nav"
          background
          layout="prev, pager, next"
          :total="totalSize2"
          :page-size="pageSize"
          @current-change="currentChange2"
        ></el-pagination>
      </div>

      <div v-if="activeName == 'two'" class="shop-list">
        <article v-for="(item, index) in tableData1" :key="item.id" class="shop-card">
          <div class="skin-art">
            <span></span>
            <img :src="item.img" alt="" @error="useSkinFallback($event, index)" />
          </div>
          <div class="shop-main">
            <strong>{{ item.name }}</strong>
            <span>{{ item.order }}</span>
            <em>{{ item.create_time }}</em>
          </div>
          <div class="shop-price">{{ moneyText(item.price) }} <i></i></div>
        </article>
        <empty-card v-if="!tableData1.length" text="暂无商城购买记录"></empty-card>
        <el-pagination
          v-if="totalSize1 > pageSize"
          class="bill-page-nav"
          background
          layout="prev, pager, next"
          :total="totalSize1"
          :page-size="pageSize"
          @current-change="currentChange1"
        ></el-pagination>
      </div>
    </section>

    <section v-else class="bill-auth-card">
      <img src="@/assets/hotpizza/hp-case-orange.png" alt="" />
      <div>
        <span>需要登录</span>
        <strong>登录后查看账单记录</strong>
        <p>充值流水、余额流水和商城购买记录都绑定当前账号，登录后可查看完整账单。</p>
      </div>
      <button @click="openLogin">登录账号</button>
    </section>
  </div>
</template>

<script>
const EmptyCard = {
  props: ["text"],
  template: '<div class="empty-card">{{ text }}</div>',
};

export default {
  components: { EmptyCard },
  data() {
    return {
      activeName: "one",
      pageSize: 10,
      totalSize: 0,
      totalSize1: 0,
      totalSize2: 0,
      tableData: [],
      tableData1: [],
      tableData2: [],
      skinFallbackImages: [
        require("../assets/hotpizza/hp-ak-green.png"),
        require("../assets/hotpizza/hp-m4-blue.png"),
        require("../assets/hotpizza/hp-mp9-red.png"),
        require("../assets/hotpizza/hp-awp-blue.png"),
      ],
    };
  },
  computed: {
    loggedIn() {
      return Boolean(this.$store.state.token);
    },
    totalCount() {
      return this.totalSize + this.totalSize1 + this.totalSize2;
    },
    activeTitle() {
      return {
        one: "充值",
        three: "余额",
        two: "商城",
      }[this.activeName];
    },
  },
  mounted() {
    if (this.loggedIn) {
      this.loadRecords();
    }
  },
  watch: {
    loggedIn(value) {
      if (value) {
        this.loadRecords();
      }
    },
  },
  methods: {
    loadRecords() {
      this.getTopupList(1);
      this.getBalanceList(1);
      this.getShoppList(1);
    },
    switchTab(name) {
      this.activeName = name;
    },
    openLogin() {
      this.$store.commit("getLogin", true);
    },
    getTopupList(page) {
      this.$axios
        .post("index/User/recharge", this.$qs.stringify({ page, pageSize: this.pageSize }))
        .then((res) => {
          if (res.data.status == 1) {
            this.totalSize = res.data.data.total;
            this.tableData = res.data.data.list;
          } else {
            this.totalSize = 0;
            this.tableData = [];
          }
        });
    },
    getShoppList(page) {
      this.$axios
        .post("index/User/skinBought", this.$qs.stringify({ page, pageSize: this.pageSize }))
        .then((res) => {
          if (res.data.status == 1) {
            this.totalSize1 = res.data.data.total;
            this.tableData1 = res.data.data.list;
          } else {
            this.totalSize1 = 0;
            this.tableData1 = [];
          }
        });
    },
    getBalanceList(page) {
      this.$axios
        .post("index/User/balanceDetail", this.$qs.stringify({ page, pageSize: this.pageSize }))
        .then((res) => {
          if (res.data.status == 1) {
            this.totalSize2 = res.data.data.total;
            this.tableData2 = res.data.data.list;
          } else {
            this.totalSize2 = 0;
            this.tableData2 = [];
          }
        });
    },
    currentChange(val) {
      this.getTopupList(val);
    },
    currentChange1(val) {
      this.getShoppList(val);
    },
    currentChange2(val) {
      this.getBalanceList(val);
    },
    payMode(item) {
      return item.mode == "weixin" ? "微信" : "支付宝";
    },
    rechargeStatus(status) {
      return {
        1: "未支付",
        2: "待支付",
        3: "支付成功，已到账",
      }[status] || "支付失败";
    },
    statusClass(status) {
      return {
        success: status == 3,
        pending: status == 1 || status == 2,
      };
    },
    balanceState(item) {
      const type = Number(item.type);
      if (type === -1 && this.balanceCurrency(item) === "cheese") {
        return "奶酪秘境开启";
      }
      if (type === 9 && String(item.remark || "").indexOf("模拟充值") !== -1) {
        return "充值到账";
      }
      return {
        1: "饰品回收",
        2: "福利赠送",
        3: "充值到账",
        4: "对战失败返还",
        5: "对战平分",
        7: "幸运饰品失败",
        8: "cdk兑换",
        9: "小麦转换披萨币",
        10: "新手任务奖励",
        11: "后台人工调整",
        "-1": "购买盲盒",
        "-2": "加入对战",
        "-3": "购买幸运饰品",
        "-4": "商城购买饰品",
      }[type] || "余额变动";
    },
    balanceCurrency(item) {
      return item.currency || ([1, -4].includes(Number(item.type)) ? "wheat" : "pizza");
    },
    currencyName(item) {
      return {
        pizza: "披萨币",
        wheat: "小麦",
        cheese: "奶酪币",
      }[this.balanceCurrency(item)] || "披萨币";
    },
    currencyClass(item) {
      return this.balanceCurrency(item);
    },
    moneyText(value) {
      return Number(value || 0).toFixed(2);
    },
    signedAmount(value) {
      const amount = Number(value || 0);
      return `${amount >= 0 ? "+" : ""}${amount.toFixed(2)}`;
    },
    useSkinFallback(event, index) {
      event.target.src = this.skinFallbackImages[index % this.skinFallbackImages.length];
    },
    goPath(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="less" scoped>
.billing-page {
  min-height: calc(100vh - 198px);
  padding: 26px 26px 74px;
  color: #f5f7ff;
  background:
    radial-gradient(circle at 45% 0, rgba(255, 138, 31, 0.16), transparent 34%),
    radial-gradient(circle at 88% 24%, rgba(0, 217, 255, 0.1), transparent 28%),
    linear-gradient(180deg, #1d202c 0%, #171923 100%);
}

button {
  font-family: inherit;
}

.bill-hero,
.bill-stats,
.bill-board,
.bill-auth-card {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.bill-hero {
  min-height: 285px;
  padding: 40px 52px;
  display: grid;
  grid-template-columns: 1.25fr 0.75fr;
  gap: 28px;
  align-items: center;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 132, 31, 0.32);
  border-radius: 22px;
  background:
    linear-gradient(135deg, rgba(39, 42, 58, 0.96), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover;
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.36);
}

.bill-hero::after {
  content: "";
  width: 560px;
  height: 560px;
  position: absolute;
  right: -180px;
  top: -180px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 147, 31, 0.31), transparent 66%);
}

.hero-copy,
.hero-orb {
  position: relative;
  z-index: 1;
}

.hero-copy span {
  color: #ff8a1f;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 0.16em;
}

.hero-copy h1 {
  margin: 12px 0 16px;
  font-size: 56px;
  line-height: 1;
  font-weight: 1000;
}

.hero-copy p {
  max-width: 620px;
  color: #aeb6c8;
  font-size: 17px;
  line-height: 1.8;
}

.hero-actions {
  margin-top: 24px;
  display: flex;
  gap: 12px;
}

.hero-actions button,
.tab-bar button,
.empty-card + button {
  cursor: pointer;
}

.hero-actions button {
  height: 46px;
  padding: 0 24px;
  color: #151620;
  background: linear-gradient(180deg, #ffcb28, #ff8a00);
  border: 0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 1000;
  box-shadow: 0 12px 28px rgba(241, 107, 0, 0.28);
}

.hero-actions .ghost {
  color: #f4f7ff;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: none;
}

.hero-orb {
  width: 235px;
  height: 235px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background:
    radial-gradient(circle, rgba(255, 209, 112, 0.26), rgba(255, 112, 24, 0.08) 58%, transparent 60%),
    #222636;
  box-shadow: inset 0 0 42px rgba(255, 150, 31, 0.16), 0 32px 70px rgba(0, 0, 0, 0.36);
}

.hero-orb i {
  width: 56px;
  height: 56px;
  margin-bottom: 12px;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
  filter: drop-shadow(0 0 18px rgba(255, 138, 0, 0.46));
}

.hero-orb strong {
  color: #ffd764;
  font-size: 42px;
  line-height: 1;
  font-weight: 1000;
}

.hero-orb em {
  margin-top: 6px;
  color: #aab3c6;
  font-style: normal;
  font-weight: 900;
}

.bill-stats {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}

.bill-stats article,
.bill-board,
.record-row,
.shop-card,
.empty-card {
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.035);
}

.bill-stats article {
  min-height: 102px;
  padding: 20px 22px;
}

.bill-stats span {
  display: block;
  color: #9aa3b8;
  font-size: 13px;
  font-weight: 900;
}

.bill-stats strong {
  display: block;
  margin-top: 12px;
  color: #f8fbff;
  font-size: 28px;
  font-weight: 1000;
}

.bill-board {
  margin-top: 18px;
  padding: 22px;
}

.tab-bar {
  display: inline-flex;
  padding: 5px;
  gap: 5px;
  background: #1c1e28;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 10px;
}

.tab-bar button {
  height: 40px;
  padding: 0 22px;
  color: #9aa3b8;
  background: transparent;
  border: 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 1000;
}

.tab-bar button.active {
  color: #151620;
  background: linear-gradient(180deg, #ffcb28, #ff8a00);
}

.record-list,
.shop-list {
  margin-top: 18px;
  display: grid;
  gap: 10px;
}

.record-row {
  min-height: 92px;
  padding: 14px 18px;
  display: grid;
  grid-template-columns: 54px 1fr 180px 130px;
  gap: 16px;
  align-items: center;
}

.row-icon {
  width: 54px;
  height: 54px;
  display: grid;
  place-items: center;
  border-radius: 14px;
  background: radial-gradient(circle, rgba(255, 138, 31, 0.28), rgba(255, 138, 31, 0.08));
}

.row-icon.balance {
  background: radial-gradient(circle, rgba(0, 217, 255, 0.24), rgba(0, 217, 255, 0.06));
}

.row-icon.balance.wheat {
  background: radial-gradient(circle, rgba(255, 216, 90, 0.28), rgba(255, 216, 90, 0.07));
}

.row-icon.balance.cheese {
  background: radial-gradient(circle, rgba(255, 143, 55, 0.28), rgba(255, 143, 55, 0.07));
}

.row-icon i,
.row-amount i,
.shop-price i {
  width: 18px;
  height: 18px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.row-icon i.wheat,
.row-amount i.wheat {
  background-image: url("../assets/pizzaking/wheat-token.svg");
}

.row-icon i.cheese,
.row-amount i.cheese {
  background:
    radial-gradient(circle at 34% 34%, #fff7a5 0 14%, transparent 15%),
    radial-gradient(circle at 67% 62%, #f58e2b 0 12%, transparent 13%),
    linear-gradient(135deg, #ffe26d, #f68a21);
  border-radius: 50%;
}

.row-main strong,
.shop-main strong {
  display: block;
  color: #f4f7ff;
  font-size: 16px;
  font-weight: 1000;
}

.row-main span,
.shop-main span,
.shop-main em {
  display: block;
  margin-top: 6px;
  color: #8f98ad;
  font-size: 13px;
  font-style: normal;
}

.row-meta span,
.row-meta em {
  display: block;
  color: #9aa3b8;
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
}

.row-meta em {
  margin-top: 7px;
}

.row-meta em.success {
  color: #94ffd0;
}

.row-meta em.pending {
  color: #ffd764;
}

.row-amount,
.shop-price {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 7px;
  color: #ffd764;
  font-size: 21px;
  font-weight: 1000;
}

.row-amount.minus {
  color: #ff8f8f;
}

.shop-card {
  min-height: 112px;
  padding: 14px 18px 14px 14px;
  display: grid;
  grid-template-columns: 96px 1fr 120px;
  gap: 18px;
  align-items: center;
}

.skin-art {
  width: 96px;
  height: 86px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 10px;
  background: #252836;
}

.skin-art span {
  width: 100px;
  height: 62px;
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(255, 38, 54, 0.2), transparent 70%);
}

.skin-art img {
  max-width: 90px;
  max-height: 72px;
  object-fit: contain;
  position: relative;
  z-index: 1;
  filter: drop-shadow(0 12px 18px rgba(0, 0, 0, 0.35));
}

.empty-card {
  padding: 34px 18px;
  color: #929bad;
  text-align: center;
  font-size: 14px;
  font-weight: 800;
}

.bill-auth-card {
  min-height: 250px;
  margin-top: 18px;
  padding: 30px;
  display: grid;
  grid-template-columns: 190px minmax(0, 1fr) auto;
  gap: 24px;
  align-items: center;
  background:
    radial-gradient(circle at 12% 50%, rgba(255, 138, 31, 0.24), transparent 34%),
    linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 132, 31, 0.24);
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.24);
}

.bill-auth-card img {
  width: 180px;
  max-height: 150px;
  object-fit: contain;
  filter: drop-shadow(0 20px 28px rgba(255, 138, 31, 0.22));
}

.bill-auth-card span {
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.bill-auth-card strong {
  display: block;
  margin-top: 8px;
  color: #fbfcff;
  font-size: 30px;
  font-weight: 1000;
}

.bill-auth-card p {
  max-width: 560px;
  margin: 10px 0 0;
  color: #aeb7c8;
  font-size: 15px;
  line-height: 1.7;
  font-weight: 800;
}

.bill-auth-card button {
  height: 44px;
  padding: 0 24px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 8px;
  font-weight: 1000;
  cursor: pointer;
  box-shadow: 0 14px 34px rgba(255, 131, 0, 0.24);
}

.bill-page-nav {
  margin-top: 14px;
  text-align: right;
}

.bill-page-nav /deep/ .el-pager li:not(.disabled).active {
  color: #151620;
  background: #ffae1d;
}

.bill-page-nav /deep/ .el-pagination.is-background .btn-next,
.bill-page-nav /deep/ .el-pagination.is-background .btn-prev,
.bill-page-nav /deep/ .el-pagination.is-background .el-pager li {
  color: #aab3c6;
  background: #242735;
}

@media screen and (max-width: 980px) {
  .billing-page {
    padding: 18px 12px 58px;
  }

  .bill-hero,
  .bill-stats,
  .bill-auth-card,
  .record-row,
  .shop-card {
    grid-template-columns: 1fr;
  }

  .bill-hero {
    padding: 30px 22px;
  }

  .hero-copy h1 {
    font-size: 42px;
  }

  .row-amount,
  .shop-price {
    justify-content: flex-start;
  }
}
</style>

<style lang="less">
.billing-page.pk-bill-page {
  padding: 32px 28px 96px !important;
}

.billing-page.pk-bill-page .bill-hero,
.billing-page.pk-bill-page .bill-stats,
.billing-page.pk-bill-page .bill-board,
.billing-page.pk-bill-page .bill-auth-card {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
}

.billing-page.pk-bill-page .bill-hero {
  min-height: 312px !important;
  border-color: rgba(255, 132, 31, 0.38) !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.billing-page.pk-bill-page .hero-orb {
  width: 260px !important;
  height: 260px !important;
}

.billing-page.pk-bill-page .bill-board {
  padding: 24px !important;
}

.billing-page.pk-bill-page .record-row {
  grid-template-columns: 58px minmax(0, 1fr) 210px 150px !important;
  min-height: 98px !important;
}

.billing-page.pk-bill-page .shop-card {
  grid-template-columns: 112px minmax(0, 1fr) 140px !important;
  min-height: 126px !important;
}

.billing-page.pk-bill-page .skin-art {
  width: 112px !important;
  height: 98px !important;
}

.billing-page.pk-bill-page .skin-art img {
  max-width: 104px !important;
  max-height: 82px !important;
}

@media screen and (max-width: 980px) {
  .billing-page.pk-bill-page {
    padding: 18px 12px 58px !important;
  }

  .billing-page.pk-bill-page .bill-hero,
  .billing-page.pk-bill-page .bill-stats,
  .billing-page.pk-bill-page .bill-board,
  .billing-page.pk-bill-page .bill-auth-card {
    width: 100% !important;
  }

  .billing-page.pk-bill-page .record-row,
  .billing-page.pk-bill-page .shop-card {
    grid-template-columns: 1fr !important;
  }
}

/* 2026-07-05 exact internal pass: account ledger full-width panels. */
.billing-page.pk-bill-page {
  min-height: calc(100vh - 199px) !important;
  padding: 24px 24px 96px !important;
  background:
    radial-gradient(ellipse at 50% 170px, rgba(255, 138, 31, 0.08), transparent 420px),
    linear-gradient(180deg, #20222f 0, #1c1d29 420px, #171923 100%) !important;
}

.billing-page.pk-bill-page .bill-hero,
.billing-page.pk-bill-page .bill-stats,
.billing-page.pk-bill-page .bill-board,
.billing-page.pk-bill-page .bill-auth-card {
  width: 100% !important;
  max-width: none !important;
}

.billing-page.pk-bill-page .bill-hero {
  min-height: 270px !important;
  padding: 30px 38px !important;
  border: 1px solid #2b2d3c !important;
  border-radius: 8px !important;
  background:
    radial-gradient(ellipse at 75% 52%, rgba(255, 138, 31, 0.14), transparent 48%),
    #20222f !important;
  box-shadow: none !important;
}

.billing-page.pk-bill-page .hero-copy h1 {
  color: #f4ead8 !important;
}

.billing-page.pk-bill-page .bill-stats article,
.billing-page.pk-bill-page .bill-board {
  border-color: #2b2d3c !important;
  background: #20222f !important;
}

.billing-page.pk-bill-page .record-row,
.billing-page.pk-bill-page .shop-card {
  border: 1px solid rgba(67, 73, 96, 0.64) !important;
  border-radius: 8px !important;
  background: #252837 !important;
}

.billing-page.pk-bill-page .record-row {
  grid-template-columns: 54px minmax(0, 1fr) 190px 140px !important;
  min-height: 86px !important;
}

.billing-page.pk-bill-page .shop-card {
  grid-template-columns: 104px minmax(0, 1fr) 126px !important;
  min-height: 112px !important;
}
</style>
